import React from 'react';
import PropTypes from 'prop-types';
// css for alerts, needs to be imported as global not through css-modules
import 'react-s-alert/dist/s-alert-default.css';
import styles from './App.scss';
import { t } from '../../services/i18nService';
import CatTriggerInProgressComponent from './CatTriggerInProgress';
import backgroundAudioService from '../../services/BackgroundAudioService';
import sessionReader from '../../store/readHelpers/SessionReader';
import LiveSessionCallContainer from '../livesession/LiveSessionCall';
import utilService from '../../services/UtilService';
import settingsReader from '../../store/readHelpers/SettingsReader';

class PauseComponent extends React.PureComponent {
    static propTypes = {
        pauseTime: PropTypes.number,
    };

    parseTimeStamp = (pauseTime) => {
        const date = new Date(pauseTime);
        const hours = date.getHours();
        const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
        return `${hours}:${minutes}`;
    };

    render() {
        const { pauseTime } = this.props;

        return (
            <div className={`${styles.pauseComponent} ${styles.centered}`}>
                <i className="fa fa-pause-circle-o" aria-hidden="true" />
                <h1>{t('session.isPaused')}</h1>
                <div className={styles.info}>
                    {t('session.pauseInfoText', { pauseTime: this.parseTimeStamp(pauseTime) })}
                </div>
            </div>
        );
    }
}

class PlayAudioComponent extends React.PureComponent {
    onPlayHandler = () => {
        backgroundAudioService.startAudioPlayFromOverlay();
    };

    onCancelHandler = () => {
        backgroundAudioService.cancelAudioPlayFromOverlay();
    };

    render() {
        return (
            <div className={styles.centered}>
                <i className="fa fa-headphones" aria-hidden="true" />
                <p>{t('session.backgroundAudioInfo')}</p>
                <p>{t('session.backgroundAudioContinue')}</p>
                <button className="btn btn-play-audio" onClick={this.onPlayHandler} type="button">
                    <i className="fa fa-play-circle" aria-hidden="true" />
                    <span className="caption">{t('session.playAudio')}</span>
                </button>
                {
                    sessionReader.isContextPreview() || sessionReader.isContextPreviewAudioScript() ?
                        <button className="btn btn-cancel-audio" onClick={this.onCancelHandler} type="button">
                            <i className="fa fa-close" aria-hidden="true" />
                            <span className="caption">{t('session.cancelAudio')}</span>
                        </button>
                        : null
                }
            </div>
        );
    }
}

class Overlay extends React.PureComponent {
    static propTypes = {
        pauseTime: PropTypes.number,
        catTriggerInProgress: PropTypes.bool,
        hasBackgroundAudio: PropTypes.bool,
        shouldShowLiveSessionCall: PropTypes.bool,
    };

    componentDidMount() {
        if (!this.overlay) return;

        const { pauseTime } = this.props;

        if (pauseTime) {
            const headerHeight = document.getElementById('headerTopBar')?.offsetHeight || 0;
            this.overlay.style.top = `${headerHeight}px`;
        }

        this.overlay.focus();
        this.overlay.addEventListener('keydown', event => utilService.handleKeyDownOnOverlay(event, this.overlay));
    }

    componentWillUnmount() {
        if (this.overlay) {
            this.overlay.removeEventListener('keydown', event => utilService.handleKeyDownOnOverlay(event, this.overlay));
        }
    }

    render() {
        const { pauseTime, hasBackgroundAudio, shouldShowLiveSessionCall, catTriggerInProgress } = this.props;
        let innerComponent = null;
        if (shouldShowLiveSessionCall) {
            innerComponent = <LiveSessionCallContainer />;
        } else if (pauseTime) {
            innerComponent = <PauseComponent pauseTime={pauseTime} />;
        } else if (hasBackgroundAudio) {
            /* We don't want the audio overlay when ENABLE_PAUSE_RESUME_OPTION_FOR_TEST_TAKER MPP is enabled
            as we are already handling the audio playback feature using backgroundAudioButton  */
            if (settingsReader.shouldAllowPauseAndResumeOptionForTestTaker()) {
                return null;
            }
            innerComponent = <PlayAudioComponent />;
        } else if (catTriggerInProgress) {
            innerComponent = <CatTriggerInProgressComponent />;
        }
        const overlayClass = [styles.overlay];
        if (pauseTime) {
            overlayClass.push(styles.pauseOverlay);
        }
        if (catTriggerInProgress) {
            overlayClass.push(styles.catTriggerInProgressOverlay);
        }

        return (
            <div
                className={overlayClass.join(' ')}
                ref={(overlay) => { this.overlay = overlay; }}
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
            >
                {innerComponent}
            </div>
        );
    }
}

export default Overlay;
